import { Link } from 'react-router-dom'
// import forvetLogo from '../../../assets/forvet_logo.svg'
import { useAppContext } from '../../../context/AppState/AppContext'

export default function HeaderLogo() {
   const { jsonBranding } = useAppContext();

   const logo = jsonBranding?.logo
   return (
      <Link className='logo-container' to='/'>
         <img src={logo} alt="logo" />
      </Link>
   )
}
